import { required, number, numeric, string, boolean, isnull, isnil } from 'vue-mc/validation'
import BaseModel from '@/models/BaseModel'

export default class Recipe extends BaseModel {
  defaults () {
    return {
      uuid: null,
      internalId: null,
      name: '',
      description: null,
      status: 'in-progress',
      subrecipe: false,
      production: 0,
      unitStock: null,
      cost: 0,
      price: null,
      quantity: 0,
      avgWeeklySale: 0,
      restaurant: null,
      section: undefined,
      area: undefined,
      editors: [],
      weeklySale: 0
    }
  }

  options () {
    return {
      identifier: 'uuid',
      methods: {
        updateStatus: 'POST',
        detail: 'GET',
        getIngredients: 'GET',
        duplicate: 'POST'
      }
    }
  }

  getDefaultMethods () {
    return {
      fetch: 'GET',
      save: 'POST',
      update: 'PUT',
      create: 'POST',
      patch: 'PUT',
      delete: 'POST'
    }
  }

  validation () {
    return {
      internalId: [(this.uuid && !this.subrecipe)
        ? required.and(string)
        : isnil.or(string)],
      name: [required.and(string)],
      description: !this.subrecipe
        ? [string.or(isnil)]
        : [isnil],
      status: [string],
      subrecipe: [boolean],
      production: [number],
      price: [(this.uuid && !this.subrecipe)
        ? required.and(number.or(numeric))
        : isnil.or(number.or(numeric))],
      section: [(this.uuid && !this.subrecipe)
        ? required.and(string)
        : isnil.or(string)],
      area: [required.and(string)],
      unitStock: [isnull.or(string)],
      cost: [number],
      quantity: [number]
    }
  }

  shouldPatch () {
    return true
  }

  detail () {
    let method = this.getOption('methods.detail')
    let route = this.getRoute('detail')
    let params = this.getRouteParameters()
    let headers = this.getDefaultHeaders()
    let url = this.getURL(route, params)

    return this.createRequest({ method, url, headers }).send()
  }

  getIngredients () {
    let method = this.getOption('methods.getIngredients')
    let route = this.getRoute('getIngredients')
    let params = this.getRouteParameters()
    let headers = this.getDefaultHeaders()
    let url = this.getURL(route, params)

    return this.createRequest({ method, url, headers }).send()
  }

  updateStatus () {
    let method = this.getOption('methods.updateStatus')
    let route = this.getRoute('updateStatus')
    let params = this.getRouteParameters()
    let headers = this.getDefaultHeaders()
    let url = this.getURL(route, params)

    return this.createRequest({ method, url, headers }).send()
  }

  patch () {
    let method = this.getOption('methods.patch')
    let route = this.getRoute('patch')
    let params = this.getRouteParameters()
    let headers = this.getDefaultHeaders()
    let url = this.getURL(route, params)

    return this.createRequest({ method, url, headers }).send()
  }

  duplicate (data) {
    let method = this.getOption('methods.duplicate')
    let route = this.getRoute('duplicate')
    let params = this.getRouteParameters()
    let headers = this.getDefaultHeaders()
    let url = this.getURL(route, params)

    return this.createRequest({ method, url, headers, data }).send()
  }

  routes () {
    return {
      fetch: `${this.API_BASE}/v1/recipes`,
      save: `${this.API_BASE}/v1/recipes`,
      delete: `${this.API_BASE}/v1/recipes/{uuid}/delete`,
      patch: `${this.API_BASE}/v1/recipes/{uuid}`,
      detail: `${this.API_BASE}/v1/recipes/{uuid}`,
      updateStatus: `${this.API_BASE}/v1/recipes/{uuid}/status/{status}`,
      getIngredients: `${this.API_BASE}/v1/recipes/{uuid}/ingredients`,
      duplicate: `${this.API_BASE}/v1/recipes/{uuid}/duplicate`
    }
  }
}
